// Utilitário de destaque de busca com escape de HTML.
//
// IMPORTANTE: o resultado é usado em dangerouslySetInnerHTML sobre conteúdo de
// contato externo (não confiável). Escapamos o HTML do texto ANTES de inserir
// o <mark>, evitando XSS armazenado. Só a tag <mark> (controlada por nós) é
// introduzida no HTML final.

export const escapeHtml = (str) =>
  String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

export const highlightSearchTerm = (text, searchTerm) => {
  const safeText = escapeHtml(text);
  if (!searchTerm || !text) return safeText;

  // Escapar metacaracteres de regex do termo digitado pelo usuário.
  const escapedTerm = String(searchTerm).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const regex = new RegExp(`(${escapedTerm})`, "gi");
  return safeText.replace(regex, "<mark>$1</mark>");
};

export default highlightSearchTerm;
